import axios, { AxiosRequestConfig } from "axios";

export async function getCityName(destcode: string) {
	const config: AxiosRequestConfig = {
		method: 'get',
		url: `${process.env.NEXT_PUBLIC_BACKEND_URL}/city/${destcode}?lng=en`,
		headers: {
			'Content-Type': 'application/json',
		},
	};

	const res =  await axios(config);

	return res.data.results[0].name.raw
}

export async function getCityNameByIATA(iata: string): Promise<string | null> {
	const config: AxiosRequestConfig = {
		method: 'get',
		url: `${process.env.NEXT_PUBLIC_BACKEND_URL}/airport/${iata}?lng=en`,
		headers: {
			'Content-Type': 'application/json',
		},
	};

	const res =  await axios(config);

	return res.data?.city
}
